<div class="flex flex-col flex-col-reverse md:flex-row md:gap-8">
  <div class="md:w-[30%] w-full">
    <p class="md:text-3xl text-xl md:mb-12 mb-8 text-center mt-4">
      Welcome to our Partner Portal
    </p>
    <app-load-spinner-wrapper [loading]="loading">
      <p class="md:text-2xl text-xl mb-4 text-left mt-4">
        Forgot Password?
      </p>
      <p class="text-left mb-4">
        Enter your email or username. We will send a message with a code to reset your password.
      </p>
      <form [formGroup]="loginForm" (ngSubmit)="resetPassword()" class="flex flex-col">
        <mat-form-field appearance="fill">
          <mat-label>Email or Username</mat-label>
          <input matInput formControlName="identifier" type="text">
          @if (loginForm.get('identifier')?.hasError('required')) {
            <mat-error>
              Email or Username is required.
            </mat-error>
          }
        </mat-form-field>

        <button
          mat-raised-button
          class="mt-1 !bg-green w-full mb-8"
          type="submit"
          [disabled]="loading || loginForm.invalid">
          <p class="md:text-lg text-base">Reset My Password</p>
        </button>
        <p><a [routerLink]="['/portal-login']" class="text-blue-600 underline">Back</a></p>
      </form>
    </app-load-spinner-wrapper>
  </div>
  <div class="md:w-[70%] w-full">
    <img
      src="assets/images/partnerPortalLoginImage.png"
      alt="Partner Portal"
      class="w-full h-auto">
  </div>
</div>
